import PostLink from './post-link'

export default PostLink
